export const SENDING_REQUEST = 'COMPANIESFORM_SENDING_REQUEST';
export const CREATE_SUCCESS = 'COMPANIESFORM_CREATE_SUCCESS';
export const UPDATE_SUCCESS = 'COMPANIESFORM_UPDATE_SUCCESS';
export const REGISTER_SUCCESS = 'COMPANIESFORM_REGISTER_SUCCESS';
export const SET_ACTIVE_SUCCESS = 'COMPANIESFORM_SET_ACTIVE_SUCCESS';
export const SET_VALUE = 'COMPANIESFORM_SET_VALUE';
export const FAILURE = 'COMPANIESFORM_FAILURE';
export const RESET_FORM = 'COMPANIESFORM_RESET_FORM';
export const DELETE_SUCCESS = 'COMPANIESFORM_DELETE_SUCCESS';